export const EXPOSE_TENANT_REQUIRED =
  'No tenant selected. This runner will not invent tenant_id=dev.';

function normalizeTenantId(value: unknown): string | null {
  if (value === undefined || value === null) return null;
  const tenant = String(value).trim();
  return tenant ? tenant : null;
}

/**
 * Tenant stamped on API Expose execute. Selected tenant wins; host default
 * (prod host → prod, dev host → dev) is the only fallback. Never invent "dev".
 */
export function resolveExposeExecuteTenant(opts: {
  selectedTenant?: string | null;
  hostTenant?: string | null;
}): string | null {
  return normalizeTenantId(opts.selectedTenant) || normalizeTenantId(opts.hostTenant);
}

export function buildExposeExecutePayload(
  workflow: string,
  workflowInput: Record<string, unknown>,
  tenant: string
): { workflow: string; input: Record<string, unknown>; context: { tenant_id: string } } {
  return {
    workflow,
    input: { ...workflowInput, tenant_id: tenant },
    context: { tenant_id: tenant },
  };
}

export function presentExposeTenantCaption(tenant: string | null): string {
  if (!tenant) return EXPOSE_TENANT_REQUIRED;
  return `Tenant: ${tenant}`;
}

export const PROD_PUBLIC_ORIGIN = 'https://devcockpit.ai';
export const DEV_PUBLIC_ORIGIN = 'https://dev.devcockpit.ai';

/**
 * Public host + tenant for Mint JWT / docs curl. Prod session → prod /
 * devcockpit.ai. Never invent tenant_id=dev.
 */
export function resolveExposePublicSurface(opts: {
  selectedTenant?: string | null;
  hostTenant?: string | null;
  isProductionHost?: boolean;
}): { tenantId: string | null; publicOrigin: string } {
  const tenant = resolveExposeExecuteTenant({
    selectedTenant: opts.selectedTenant,
    hostTenant: opts.hostTenant,
  });
  const useProdOrigin = tenant === 'prod' || (tenant !== 'dev' && Boolean(opts.isProductionHost));
  return {
    tenantId: tenant,
    publicOrigin: useProdOrigin ? PROD_PUBLIC_ORIGIN : DEV_PUBLIC_ORIGIN,
  };
}

export function buildExposeDocsCurl(opts: {
  tenantId: string | null;
  publicOrigin: string;
  path?: string;
}): string {
  const path = opts.path || '/public/trekker/equipment?limit=50';
  const tenantLine = opts.tenantId
    ? `  -H "x-tenant-id: ${opts.tenantId}" \\`
    : '  -H "x-tenant-id: $TENANT_ID" \\';
  return `curl -s \\
  -H "Authorization: Bearer $APP_JWT" \\
${tenantLine}
  "${opts.publicOrigin}${path}"`;
}

/** Clear a sticky data-source error when the selected app changes. */
export function resetDataSourceLoadError(): null {
  return null;
}
